import type { RootState } from "Data/Store/Store";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { openAccountModeModalAction } from "./OpenAccountModeModalAction";
import { closeAccountModeModalAction } from "./CloseAccountModeModalAction";
import { resetAccountModeModalAction } from "./ResetAccountModeModalAction";
import { AccountModeModalState } from "@model/AccountModeModal.model";
import { chooseGuestModeAction } from "./ChooseGuestModeAction";

const accountModeModalSelector = (state: RootState) =>
  state.accountModeModalReducer;

export const AccountModeModalStoreImplementation = () => {
  const dispatch = useDispatch();
  const modalState = useSelector<RootState, AccountModeModalState>(
    accountModeModalSelector
  );

  const openAccountModeModal = useCallback(
    () => openAccountModeModalAction()(dispatch),
    [dispatch]
  );

  const closeAccountModeModal = useCallback(
    () => closeAccountModeModalAction()(dispatch),
    [dispatch]
  );

  const resetAccountModeModal = useCallback(
    () => resetAccountModeModalAction()(dispatch),
    [dispatch]
  );

  const chooseGuestMode = useCallback(
    () => chooseGuestModeAction()(dispatch),
    [dispatch]
  );

  return {
    modalState,
    openAccountModeModal,
    closeAccountModeModal,
    resetAccountModeModal,
    chooseGuestMode,
  };
};
